/** Supported persisted appearance modes. */
export const THEME_MODES = ['system', 'light', 'dark'] as const;

/** Allowed user preference values for theme mode persistence. */
export type ThemeMode = (typeof THEME_MODES)[number];

/** Fully resolved runtime scheme applied to the document root. */
export type ResolvedThemeMode = Exclude<ThemeMode, 'system'>;

/** Root class name used by PrimeNG and Tailwind dark mode selectors. */
export const APP_DARK_CLASS = 'app-dark';

/** Local storage key used to persist the selected theme mode. */
export const THEME_STORAGE_KEY = 'pt.theme.mode';

/** Media query used to resolve system preference in `system` mode. */
export const PREFERS_DARK_COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';

/** Runtime type guard for unknown persisted mode values. */
export function isThemeMode(value: unknown): value is ThemeMode {
  return typeof value === 'string' && THEME_MODES.includes(value as ThemeMode);
}
